import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OfficeOverheadService from '../../../Services/OfficeOverheadService';

// Trivial placeholder: the wizard only instantiates windowDescription.itemType when no
// editedItem prop is passed. OfficeOverheadPanel always passes the selected overhead item
// (crudType=Update), so this is never invoked, but it keeps the windowDescription contract
// satisfied.
class OfficeOverheadEditItem {}

export default class EditOfficeOverheadWindowDescription {
  static titleForEdit = (item) => `Edit Office Overhead Rate ${item.Quarter}`;
  static itemType = OfficeOverheadEditItem;
  static finishButtonLabel = 'Save';
  static messageOnSuccess = 'Office overhead has been saved.';

  // Mirrors the old panel's clickOnSubmitButton: the whole edited overhead item is posted back.
  // MUST return the promise (wizard contract).
  static serviceFunction = (edited) => OfficeOverheadService.EditOfficeOverhead(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'PricingOverheadRate',
          label: 'Pricing Overhead Rate',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'ActualOverheadRate',
          label: 'Actual Overhead Rate',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
      ],
    },
  ];
}
